const config = {
  appUrl: "https://amgglobaldev.tainosystems.com/api/",
  // appUrl: "http://localhost:8546/",
  googleMapsApiKey: "AIzaSyB3n919-1MbNDn_jkTYcM0v4wVCoAWxRA0",
  wssUrl: "wss://amgglobaldev.tainosystems.com/api/",
  // wssUrl: "wss://localhost:8546/",
  routes: {
    register: "register",
    login: "login",
    getLoginData: "auth/fetchlogindata",
    socialLogin: (provider) => `auth/${provider}`,
    logout: "logout",
    forgotPwd: "forgotpassword",
    users: "users",
    user: "user",
    userId: (id) => `user/${id}`,
    userStatus: (id, status) => `user/${id}/${status}`,
    changePwd: (id) => `changepassword/${id}`,
    changeTemPwd: `changetemppassword`,
    resetPwd: (id) => `resetpassword/${id}`,
    business: "business",
    businessDetails: (id) => `business/${id}`,
    sellerBusinessDetails: (id) => `sellerprofile/${id}/businesses`,
    BuyerBusinessList: "buyerprofile/listbusinesses",
    buyerProfileLogin: "buyerprofile",
    sellerProfileLogin: "sellerprofile",
    professionalProfileLogin: "professionalprofile",
    buyerProfiles: "buyerprofiles",
    sellerProfiles: "sellerprofiles",
    professionalProfiles: "professionalprofiles",
    buyerProfile: (id) => `buyerprofile/${id}`,
    sellerProfile: (id) => `sellerprofile/${id}`,
    professionalProfile: (id) => `professionalprofile/${id}`,
    buyerProfileCreate: "buyerprofile",
    sellerProfileCreate: "sellerprofile",
    professionalProfileCreate: "professionalprofile",
    offers: "offers",
    offerDetails: (id) => `offer/${id}`,
    createOffer: "offer",
    offersSent: "offers/sent",
    offersReceived: "offers/received",
    bookmarkBusiness: (id) => `ad/${id}`,
    interestBusiness: (id) => `business/${id}/interestedbuyer`,
    acceptOffer: (id) => `offer/${id}/accept`,
    rejectOffer: (id) => `offer/${id}/reject`,
    offersPerbusiness: (id) => `offers/business/${id}`,
    getAllBookmarkedBusinesses: "ads",
    contractTypes: "contracttypes",
    addContractType: "contracttype",
    updateContractType: (id) => `contracttype/${id}`,
    contracts: "contracts",
    contractsPerProfile: (id) => `contracts/profile/${id}`,
    contractsPerBusiness: (id) => `contracts/business/${id}`,
    createContract: "contract",
    updateContract: (id) => `contract/${id}`,
    contractReminder: (id) => `contract/${id}/sendreminder`,
    offersRaisedBusinesses: "buyerprofile/listbusinesses/raisedoffer",
    currencies: "currencies",
    activeCurrencies: "currencies/active",
    updateCurrencyStatus: (id, cond) =>
      `currency/${id}/${cond ? "deactivate" : "activate"}`,
    incomeStatement: (id) => `business/${id}/incomestatement`,
    incomeStatementFile: (id) => `business/${id}/incomestatementfile`,
    roles: "roles",
    createRole: "role",
    role: (id) => `role/${id}`,
    permissions: "permissions",
    addPermission: (roleId, permissionId) => `role/${roleId}/${permissionId}`,
    deletePermission: (roleId, permissionId) =>
      `role/${roleId}/${permissionId}`,
    adminDashboard: "admin/dashboard",
    buyerDashboard: "buyerprofile/dashboard",
    sellerDashboard: "sellerprofile/dashboard",
    tenants: "tenants",
    createTenant: "tenant",
    tenant: (id) => `tenant/${id}`,
    rates: "rates",
    ws: (token) => `ws?token=${token}`,
    notificationsPerProfile: "notifications/profile",
    updateNotificationSeen: (id) => `notification/${id}/seen`,
    excel: "excel",
    updateExcel: (id) => `excel/used/${id}`,
    getExcel: (id) => `excel/used/${id}`,
    deleteExcel: (id) => `excel/${id}`,
    createReport: (id) => `report/${id}`,
    reports: "reports",
    report: (id) => `report/${id}`,
    documents: "documents",
    createDocument: "document",
    updateDocument: (id) => `document/${id}`,
    searchRepresentative: `representative/search`,
    assignRepresentative: (businessId, rid) =>
      `business/${businessId}/assign/${rid}`,
    reAssignRepresentative: (businessId, rid) =>
      `business/${businessId}/reassign/${rid}`,
    getAssignBusiness: "businesses/assigned",
    getRepStatus: (repId) => `representative/status/${repId}`,
    getRequestedProfessionalList: (businessId) =>
      `professional/list/${businessId}`,
    getAssignedProfessionalList: (businessId) =>
      `assignedprofessional/${businessId}`,
    getRoomList: (userType) => `rooms?list_type=${userType}`,
    createRate: "rate",
    createChatRoom: (businessId) => `room/${businessId}`,
    getChatHistory: (roomId) => `chat/${roomId}`,
    unseenMessage: "chat/unseencnt",
    profileComplete: "profilecomplete",
    getBusinessFileUploaderLink: "file/uploadurl",
    uploadFile: "file",
    uploadVoiceNote: "voice-note",
    fileViewUrl: "file/view",
    requiredFileList: "requiredfilelist",
    createNote: "note",
    getBusinessNotes: (id) => `business-notes/${id}`,
    getNote: (id) => `note/${id}`,
    updateNote: (id) => `note/${id}`,
    deleteNote: (id) => `note/${id}`,
    getNoteList: "notes",
    getDealProgress: (id) => `business-progress/${id}`,
    uploadExcelFile: (id) => `business/${id}/incomestatementfile`,
    createTemplateApi: "api/templates",
    eventConfigsApi: "api/event-config",
    deleteTemplateApi: (id) => `api/templates/${id}`,
    updateTemplateApi: (id) => `api/templates/${id}`,
    updateEventConfigApi: (id) => `api/event-config/${id}`,
    fetchOutboxApi: "api/comms-outbox",
    fetchRepresentativesApi: "users?filters=role:eq:4",
    fetchAdministratrosApi: "users?filters=role:eq:2",
    retryMessageApi: (id) => `api/comms-outbox/${id}/retry`,
    createProgressNote: "business-progress/note",
    updateProgressNote: "business-progress/note", // PUT with ID
    deleteProgressNote: "business-progress/note", // DELETE with ID
    getProgressNotes: "business-progress/note",
    fileDelete: (id) => `file/${id}`,
  },
};
//representatives
//buyers
//selers
//professionals

export default config;
